module.exports = __webpack_public_path__ + "static/img/pico35.bf2e0c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico35.png
// module id = OV/W
// module chunks = 0